import { CityLandingPage } from "../components/CityLandingPage";

export function WebdesignRuhland() {
  return <CityLandingPage city="Ruhland" citySlug="ruhland" variant="webdesign" />;
}
